import React from 'react';
import { Button } from '@etherisc/ui-kit';
import type { ButtonProps } from '@etherisc/ui-kit';

interface NeutralButtonProps extends Omit<ButtonProps, 'variant' | 'children'> {
  children: React.ReactNode;
  fullWidth?: boolean;
  wide?: boolean;
  style?: React.CSSProperties;
  loadingText?: string;
}

/**
 * Semantic button component for Neutral/Secondary actions
 * Uses GREY color following UX guidelines for secondary, neutral actions
 * Examples: Cancel, Close, Back, Dismiss
 * Uses @etherisc/ui-kit Button with variant="secondary"
 */
export function NeutralButton(props: NeutralButtonProps) {
  const { 
    children, 
    fullWidth = false,
    wide = false,
    className = '',
    style = {},
    loadingText, // eslint-disable-line @typescript-eslint/no-unused-vars
    ...buttonProps 
  } = props;
  // Handle sizing classes - adapt to ui-kit if needed
  const sizeClasses = fullWidth ? 'w-full max-w-[500px]' : wide ? 'w-48' : '';
  const combinedClassName = `flex items-center gap-2 ${sizeClasses} ${className}`.trim();
  
  return (
    <Button 
      {...buttonProps}
      variant="secondary"
      className={combinedClassName}
      style={style}
    >
      {children}
    </Button>
  );
}

 